// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605261033/js/" + chunkId + "." + {"44":"e3c60388","225":"65964caa","481":"7a7cbe83","486":"f89ee258","770":"330e391f"}[chunkId] + ".0.10736218972664413.chunk.js";
};